import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

// New UI (docs/ui_redesign/18-ux-review.md, R22): Invoice Model Setup's header, like the invoice editor's. It says
// which model this is and how it was opened; ✕ runs the same close as the setup's own Cancel (props.onClose).
const MODULE = { 1: 'Media', 2: 'Production', 3: 'Broadcast' };
const MODE = { New: 'New model', NewSample: 'New model from this invoice', Edit: 'Edit', Copy: 'Copy', View: 'View', AssignVendor: 'Assign vendor' };

export function modelSetupTitle(info = {}) {
	const row = info.rowData || {};
	return {
		eyebrow: [MODULE[Number(info.modelDefId)] || '', 'Invoice model', MODE[info.mode] || info.mode || ''].filter(Boolean).join(' · '),
		title: row.displayModelName || row.documentModelName || row.modelName || 'New model',
		tag: row.documentModelNameTag || row.modelTag || '',
		type: row.type || ''
	};
}

export default function ModelSetupHeader({ info, onClose }) {
	const t = modelSetupTitle(info);
	return (
		<header className="apw2-ms-head">
			<button type="button" className="apw2-iconbtn lg" aria-label="Close" title="Close" onClick={e => onClose && onClose(e)}><CloseIcon fontSize="inherit" /></button>
			<div className="apw2-ed-title">
				<span className="apw2-ed-eyebrow">{t.eyebrow}</span>
				<h1>{t.title}</h1>
			</div>
			{t.tag ? <span className="apw2-chip t-neutral">{t.tag}</span> : null}
			{t.type ? <span className="apw2-chip t-info">{t.type}</span> : null}
		</header>
	);
}
